/**
 * GTA Locations Data
 * Centralized data for Great Toronto Area location pages
 * Easy to maintain and extend with new cities
 */

export const gtaCities = [
    {
        slug: 'markham',
        name: 'Markham',
        displayName: 'Markham',
        province: 'Ontario',
        waterHardness: '7.4 gpg',
        waterHardnessGPG: 7.4,
        description: 'Markham is one of Canada\'s most diverse cities, located just north of Toronto. Known for its excellent quality of life and thriving tech sector.',
        serviceAreas: [
            'Downtown Markham',
            'Unionville',
            'Thornhill',
            'Angus Glen',
            'Cornell',
            'Box Grove'
        ],
        neighborhoods: [
            'Unionville Heritage',
            'Markham Village',
            'Milliken Mills',
            'Wismer',
            'Cachet'
        ],
        postalCodes: ['L3R', 'L3P', 'L3T', 'L6B', 'L6C', 'L6E'],
        coordinates: {
            lat: 43.8561,
            lng: -79.3370
        },
        priority: 1 // Primary location
    },
    {
        slug: 'toronto',
        name: 'Toronto',
        displayName: 'Toronto',
        province: 'Ontario',
        waterHardness: '7 gpg',
        waterHardnessGPG: 7,
        description: 'Canada\'s largest city and economic hub. Toronto\'s diverse neighborhoods each have unique water quality characteristics.',
        serviceAreas: [
            'Downtown Toronto',
            'North York',
            'Scarborough',
            'Etobicoke',
            'East York',
            'York'
        ],
        neighborhoods: [
            'Downtown Core',
            'The Beaches',
            'Leaside',
            'Forest Hill',
            'Rosedale',
            'Leslieville'
        ],
        postalCodes: ['M4B', 'M4C', 'M4E', 'M4G', 'M4H', 'M4J', 'M4K', 'M4L', 'M4M', 'M4N', 'M4P', 'M4R', 'M4S', 'M4T', 'M4V', 'M4W', 'M4X', 'M4Y', 'M5A', 'M5B', 'M5C', 'M5E', 'M5G', 'M5H', 'M5J', 'M5K', 'M5L', 'M5M', 'M5N', 'M5P', 'M5R', 'M5S', 'M5T', 'M5V', 'M5W', 'M5X', 'M6A', 'M6B', 'M6C', 'M6E', 'M6G', 'M6H', 'M6J', 'M6K', 'M6L', 'M6M', 'M6N', 'M6P', 'M6R', 'M6S', 'M8V', 'M8W', 'M8X', 'M8Y', 'M8Z', 'M9A', 'M9B', 'M9C', 'M9P', 'M9R', 'M9V', 'M9W'],
        coordinates: {
            lat: 43.6532,
            lng: -79.3832
        },
        priority: 2
    },
    {
        slug: 'mississauga',
        name: 'Mississauga',
        displayName: 'Mississauga',
        province: 'Ontario',
        waterHardness: '7 - 7.6 gpg',
        waterHardnessGPG: 7.3,
        description: 'Canada\'s sixth-largest city, located on the shores of Lake Ontario. A major business hub with growing residential communities.',
        serviceAreas: [
            'Mississauga City Centre',
            'Port Credit',
            'Streetsville',
            'Meadowvale',
            'Erin Mills',
            'Malton'
        ],
        neighborhoods: [
            'Square One',
            'Port Credit',
            'Streetsville',
            'Meadowvale',
            'Erin Mills',
            'Clarkson'
        ],
        postalCodes: ['L4T', 'L4W', 'L4X', 'L4Y', 'L4Z', 'L5A', 'L5B', 'L5C', 'L5E', 'L5G', 'L5H', 'L5J', 'L5K', 'L5L', 'L5M', 'L5N', 'L5R', 'L5S', 'L5T', 'L5V', 'L5W'],
        coordinates: {
            lat: 43.5890,
            lng: -79.6441
        },
        priority: 3
    },
    {
        slug: 'brampton',
        name: 'Brampton',
        displayName: 'Brampton',
        province: 'Ontario',
        waterHardness: '7 - 7.6 gpg',
        waterHardnessGPG: 7.3,
        description: 'A rapidly growing city in the Peel Region, known for its diverse community and strong industrial sector.',
        serviceAreas: [
            'Brampton City Centre',
            'Bramalea',
            'Springdale',
            'Heart Lake',
            'Mount Pleasant',
            'Gore'
        ],
        neighborhoods: [
            'Bramalea',
            'Springdale',
            'Heart Lake',
            'Mount Pleasant',
            'Gore',
            'Professionals Corner'
        ],
        postalCodes: ['L6P', 'L6R', 'L6S', 'L6T', 'L6V', 'L6W', 'L6X', 'L6Y', 'L6Z', 'L7A', 'L7B', 'L7C'],
        coordinates: {
            lat: 43.7315,
            lng: -79.7624
        },
        priority: 4
    },
    {
        slug: 'vaughan',
        name: 'Vaughan',
        displayName: 'Vaughan',
        province: 'Ontario',
        waterHardness: '7.5 gpg',
        waterHardnessGPG: 7.5,
        description: 'A growing city with excellent residential communities and strong commercial development.',
        serviceAreas: [
            'Vaughan Metropolitan Centre',
            'Woodbridge',
            'Maple',
            'Kleinburg',
            'Thornhill',
            'Concord'
        ],
        neighborhoods: [
            'Woodbridge',
            'Maple',
            'Kleinburg',
            'Concord',
            'Thornhill',
            'Vellore Village'
        ],
        postalCodes: ['L4H', 'L4J', 'L4K', 'L4L', 'L4M', 'L6A'],
        coordinates: {
            lat: 43.8361,
            lng: -79.4983
        },
        priority: 5
    },
    {
        slug: 'richmond-hill',
        name: 'Richmond Hill',
        displayName: 'Richmond Hill',
        province: 'Ontario',
        waterHardness: '7.4 gpg',
        waterHardnessGPG: 7.4,
        description: 'A vibrant community known for its excellent schools, parks, and family-friendly neighborhoods.',
        serviceAreas: [
            'Richmond Hill Centre',
            'Oak Ridges',
            'Jefferson',
            'Mill Pond',
            'Crosby',
            'Langstaff'
        ],
        neighborhoods: [
            'Oak Ridges',
            'Mill Pond',
            'Jefferson',
            'Crosby',
            'Langstaff',
            'Observatory'
        ],
        postalCodes: ['L4B', 'L4C', 'L4E', 'L4S'],
        coordinates: {
            lat: 43.8828,
            lng: -79.4403
        },
        priority: 6
    },
    {
        slug: 'oakville',
        name: 'Oakville',
        displayName: 'Oakville',
        province: 'Ontario',
        waterHardness: '8.7 gpg',
        waterHardnessGPG: 8.7,
        description: 'An upscale lakeside community known for its excellent quality of life and waterfront properties.',
        serviceAreas: [
            'Downtown Oakville',
            'Bronte',
            'Glen Abbey',
            'Rural Oakville',
            'Uptown Core',
            'Iroquois Ridge'
        ],
        neighborhoods: [
            'Downtown Oakville',
            'Bronte',
            'Glen Abbey',
            'Iroquois Ridge',
            'Westoak Trails',
            'Old Oakville'
        ],
        postalCodes: ['L6H', 'L6J', 'L6K', 'L6L', 'L6M'],
        coordinates: {
            lat: 43.4675,
            lng: -79.6877
        },
        priority: 7
    },
    {
        slug: 'ajax',
        name: 'Ajax',
        displayName: 'Ajax',
        province: 'Ontario',
        waterHardness: '7.3 gpg',
        waterHardnessGPG: 7.3,
        description: 'A lakeside community in Durham Region with growing residential and commercial sectors.',
        serviceAreas: [
            'Ajax Town Centre',
            'South Ajax',
            'North Ajax',
            'West Ajax',
            'Pickering Village'
        ],
        neighborhoods: [
            'Ajax Town Centre',
            'Westney Heights',
            'Westwood',
            'Harwood',
            'Woodlands'
        ],
        postalCodes: ['L1S', 'L1T', 'L1Z'],
        coordinates: {
            lat: 43.8583,
            lng: -79.0364
        },
        priority: 8
    },
    {
        slug: 'pickering',
        name: 'Pickering',
        displayName: 'Pickering',
        province: 'Ontario',
        waterHardness: '7.3 gpg',
        waterHardnessGPG: 7.3,
        description: 'A growing city in Durham Region with excellent access to Toronto and beautiful natural areas.',
        serviceAreas: [
            'Pickering Town Centre',
            'Liverpool',
            'Highbush',
            'Bay Ridges',
            'Dunbarton',
            'Green River'
        ],
        neighborhoods: [
            'Bay Ridges',
            'Liverpool',
            'Highbush',
            'Dunbarton',
            'Green River',
            'Amberlea'
        ],
        postalCodes: ['L1V', 'L1W', 'L1X', 'L1Y'],
        coordinates: {
            lat: 43.8374,
            lng: -79.0863
        },
        priority: 9
    },
    {
        slug: 'whitby',
        name: 'Whitby',
        displayName: 'Whitby',
        province: 'Ontario',
        waterHardness: '7.3 gpg',
        waterHardnessGPG: 7.3,
        description: 'A welcoming community in Durham Region with excellent schools and family amenities.',
        serviceAreas: [
            'Whitby Town Centre',
            'Brooklin',
            'Rossland',
            'Pringle Creek',
            'Lynde Creek',
            'Williamsburg'
        ],
        neighborhoods: [
            'Brooklin',
            'Rossland',
            'Pringle Creek',
            'Lynde Creek',
            'Williamsburg',
            'Taunton'
        ],
        postalCodes: ['L1N', 'L1P', 'L1R'],
        coordinates: {
            lat: 43.8975,
            lng: -78.9428
        },
        priority: 10
    },
    {
        slug: 'oshawa',
        name: 'Oshawa',
        displayName: 'Oshawa',
        province: 'Ontario',
        waterHardness: '7.3 gpg',
        waterHardnessGPG: 7.3,
        description: 'The largest city in Durham Region, known for its automotive history and growing tech sector.',
        serviceAreas: [
            'Downtown Oshawa',
            'North Oshawa',
            'South Oshawa',
            'East Oshawa',
            'West Oshawa',
            'Ritson'
        ],
        neighborhoods: [
            'Downtown Oshawa',
            'North Oshawa',
            'South Oshawa',
            'Vanier',
            'O\'Neill',
            'Ritson'
        ],
        postalCodes: ['L1G', 'L1H', 'L1J', 'L1K', 'L1L'],
        coordinates: {
            lat: 43.8975,
            lng: -78.8659
        },
        priority: 11
    },
    {
        slug: 'burlington',
        name: 'Burlington',
        displayName: 'Burlington',
        province: 'Ontario',
        waterHardness: '8.7 gpg',
        waterHardnessGPG: 8.7,
        description: 'A beautiful lakeside city in Halton Region, known for its waterfront and excellent quality of life.',
        serviceAreas: [
            'Downtown Burlington',
            'Aldershot',
            'Alton',
            'Tyandaga',
            'Roseland',
            'Brant Hills'
        ],
        neighborhoods: [
            'Downtown Burlington',
            'Aldershot',
            'Alton',
            'Tyandaga',
            'Roseland',
            'Brant Hills'
        ],
        postalCodes: ['L7L', 'L7M', 'L7N', 'L7P', 'L7R', 'L7S', 'L7T'],
        coordinates: {
            lat: 43.3255,
            lng: -79.7990
        },
        priority: 12
    },
    {
        slug: 'newmarket',
        name: 'Newmarket',
        displayName: 'Newmarket',
        province: 'Ontario',
        waterHardness: '8.2 gpg',
        waterHardnessGPG: 8.2,
        description: 'A thriving community in York Region with a charming historic downtown and strong family-oriented neighborhoods.',
        serviceAreas: [
            'Newmarket Town Centre',
            'Stonehaven',
            'Arbor Hill',
            'Summerhill Estates',
            'Woodland Hill',
            'Bristol-London'
        ],
        neighborhoods: [
            'Main Street Heritage',
            'Stonehaven',
            'Arbor Hill',
            'Summerhill Estates',
            'Woodland Hill',
            'Glenway'
        ],
        postalCodes: ['L3X', 'L3Y'],
        coordinates: {
            lat: 44.0558,
            lng: -79.4604
        },
        priority: 13
    },
    {
        slug: 'aurora',
        name: 'Aurora',
        displayName: 'Aurora',
        province: 'Ontario',
        waterHardness: '7.6 gpg',
        waterHardnessGPG: 7.6,
        description: 'An upscale community in York Region known for its excellent schools and family-friendly atmosphere.',
        serviceAreas: [
            'Aurora Town Centre',
            'Oak Ridges Moraine',
            'Wellington',
            'Industrial Parkway',
            'Bayview Northeast',
            'St. John\'s'
        ],
        neighborhoods: [
            'Wellington',
            'Oak Ridges Moraine',
            'Bayview Northeast',
            'Industrial Parkway',
            'St. John\'s',
            'Woodlands'
        ],
        postalCodes: ['L4G'],
        coordinates: {
            lat: 43.9938,
            lng: -79.4641
        },
        priority: 14
    },
    {
        slug: 'milton',
        name: 'Milton',
        displayName: 'Milton',
        province: 'Ontario',
        waterHardness: '8.8–22.3 gpg (supply-dependent)',
        waterHardnessGPG: 15.55,
        description: 'One of Canada\'s fastest-growing communities in Halton Region with excellent parks and trails.',
        serviceAreas: [
            'Milton Town Centre',
            'Dempsey',
            'Hawthorne Village',
            'Timberlea',
            'Willmont',
            'Bronte Meadows'
        ],
        neighborhoods: [
            'Hawthorne Village',
            'Timberlea',
            'Willmont',
            'Bronte Meadows',
            'Old Milton',
            'Dempsey'
        ],
        postalCodes: ['L9T', 'L0P'],
        coordinates: {
            lat: 43.5183,
            lng: -79.8774
        },
        priority: 15
    },
    {
        slug: 'georgetown',
        name: 'Georgetown',
        displayName: 'Georgetown',
        province: 'Ontario',
        waterHardness: '8.8–24 gpg (supply-dependent)',
        waterHardnessGPG: 16.4,
        description: 'A charming town in Halton Hills with a rich heritage and strong community spirit.',
        serviceAreas: [
            'Downtown Georgetown',
            'Stewarttown',
            'Norval',
            'Glen Williams',
            'Silver Creek',
            'Esquesing'
        ],
        neighborhoods: [
            'Downtown Georgetown',
            'Stewarttown',
            'Norval',
            'Glen Williams',
            'Silver Creek'
        ],
        postalCodes: ['L7G'],
        coordinates: {
            lat: 43.6501,
            lng: -79.9163
        },
        priority: 16
    },
    {
        slug: 'stouffville',
        name: 'Stouffville',
        displayName: 'Stouffville',
        province: 'Ontario',
        waterHardness: '18.6 gpg',
        waterHardnessGPG: 18.6,
        description: 'A growing community in Whitchurch-Stouffville with rural charm and modern amenities.',
        serviceAreas: [
            'Stouffville Town Centre',
            'Balmoral',
            'Latcham',
            'Bloomington',
            'Vandorf',
            'Ballantrae'
        ],
        neighborhoods: [
            'Balmoral',
            'Latcham',
            'Bloomington',
            'Vandorf',
            'Ballantrae',
            'Ringwood'
        ],
        postalCodes: ['L4A'],
        coordinates: {
            lat: 43.9702,
            lng: -79.2483
        },
        priority: 17
    },
    {
        slug: 'king-city',
        name: 'King City',
        displayName: 'King City',
        province: 'Ontario',
        waterHardness: '7.7 gpg',
        waterHardnessGPG: 7.7,
        description: 'An affluent community in King Township known for equestrian estates and rural estates with well water systems.',
        serviceAreas: [
            'King City Village',
            'Pottageville',
            'Schomberg',
            'Nobleton',
            'Ansnorveldt',
            'Loretto'
        ],
        neighborhoods: [
            'King City Village',
            'Pottageville',
            'Schomberg',
            'Nobleton',
            'Ansnorveldt'
        ],
        postalCodes: ['L7B', 'L0G'],
        coordinates: {
            lat: 43.9294,
            lng: -79.5242
        },
        priority: 18
    },
    {
        slug: 'caledon',
        name: 'Caledon',
        displayName: 'Caledon',
        province: 'Ontario',
        waterHardness: '7.5 gpg',
        waterHardnessGPG: 7.5,
        description: 'A largely rural municipality in Peel Region with both urban centers and agricultural lands.',
        serviceAreas: [
            'Bolton',
            'Caledon Village',
            'Caledon East',
            'Alton',
            'Inglewood',
            'Terra Cotta'
        ],
        neighborhoods: [
            'Bolton',
            'Caledon Village',
            'Caledon East',
            'Alton',
            'Inglewood'
        ],
        postalCodes: ['L7E', 'L7C'],
        coordinates: {
            lat: 43.8668,
            lng: -79.8579
        },
        priority: 19
    }
];

/**
 * Get city data by slug
 */
export function getCityBySlug(slug) {
    return gtaCities.find(city => city.slug === slug);
}

/**
 * Get all city slugs for static generation
 */
export function getAllCitySlugs() {
    return gtaCities.map(city => ({ slug: city.slug }));
}

/**
 * Get cities sorted by priority
 */
export function getCitiesByPriority() {
    return [...gtaCities].sort((a, b) => a.priority - b.priority);
}

/**
 * Get nearby cities (within GTA)
 */
export function getNearbyCities(currentCitySlug, limit = 3) {
    const currentCity = getCityBySlug(currentCitySlug);
    if (!currentCity) return [];
    
    return gtaCities
        .filter(city => city.slug !== currentCitySlug)
        .sort((a, b) => Math.abs(a.waterHardnessGPG - currentCity.waterHardnessGPG) - Math.abs(b.waterHardnessGPG - currentCity.waterHardnessGPG))
        .slice(0, limit);
}
